var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccurateInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8473 5.61391L19.0189 5.71851L19.2198 5.72329L22.5535 5.80262L24.0105 8.80204L24.0983 8.98281L24.2647 9.09546L27.0262 10.9645L26.6303 14.2755L26.6065 14.475L26.6856 14.6598L27.9983 17.7251L25.8752 20.2964L25.7472 20.4514L25.7139 20.6496L25.1609 23.938L21.9847 24.9533L21.7933 25.0145L21.6581 25.1632L19.4151 27.6306L16.1941 26.7676L16 26.7155L15.8059 26.7676L12.5849 27.6306L10.3419 25.1632L10.2067 25.0145L10.0153 24.9533L6.83907 23.938L6.28613 20.6496L6.2528 20.4514L6.12484 20.2964L4.00173 17.7251L5.31441 14.6598L5.39353 14.475L5.36967 14.2755L4.97376 10.9645L7.7353 9.09546L7.90173 8.98281L7.98955 8.80204L9.44654 5.80262L12.7802 5.72329L12.9811 5.71851L13.1527 5.61391L16 3.87835L18.8473 5.61391Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7603 12.6038L14.7559 19.6123L11.2498 16.1073",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccurateInfoIcon);
export default __webpack_public_path__ + "static/media/accurate-info-icon.8c2059be08963368c1e503dad241fdbc.svg";
export { ForwardRef as ReactComponent };